













































































































































































































































import HalfModal from '@/components/molecules/HalfModal.vue'
import { colorFamilyOptions } from '@hl-itemlist/model/color-family'
import {
  BooleanFilterDefinition,
  booleanFilterDefinitions,
  BooleanFilterKey,
  EnumFilterKey,
  enumFilterOptions,
  EnumFilterValues,
  ExpirationPeriod,
  expirationPeriodOptions,
  ItemListCondition,
  PowerFilter,
  SelectOption,
  setKeyword,
  StringArrayFilterKey,
  toggleArrayValue,
  toggleBooleanFilter,
  toggleEnumFilter,
  toggleExpirationPeriod,
} from '@hl-itemlist/model/condition'
import { DraftStats } from '@hl-itemlist/model/draft-stats'
import { LensSizeCandidatesState } from '@hl-itemlist/model/lens-size-candidates-state'
import Vue, { PropType } from 'vue'

// キーワードの入力確定とみなすまでの待ち時間。文字入力だけは連続入力中の1文字ごとに親へ通知せず、
// 最後の入力から一呼吸おいて1回だけ通知する(タップ系の操作と違い、親は編集ごとに即時件数取得するため)
const KEYWORD_DEBOUNCE_MS = 300

function pickBooleanDefinitions(keys: BooleanFilterKey[]): BooleanFilterDefinition[] {
  return keys.map((key) => {
    const matched = booleanFilterDefinitions.find(definition => definition.key === key)

    return matched !== undefined ? matched : { key, label: key }
  })
}

const saleDefinitions = pickBooleanDefinitions(['onlyBundleDiscountsApplied', 'onlyTrialProducts'])
const colorOptionDefinitions = pickBooleanDefinitions(['onlySuikou', 'onlyNonRotatingSuikou'])
const astigmatismDefinition = pickBooleanDefinitions(['onlyAstigmatism'])[0]
const optionDefinitions = pickBooleanDefinitions(['onlyUvCut', 'onlyMoist', 'onlySilicon'])

// 度数はiOSアプリの絞り込み画面と同じ2択(度あり/度なし)+乱視。
// with_plus_power(遠視対応あり)はUIには出さないが、URL/BFFの語彙としては受け付ける
const powerOptions: ReadonlyArray<SelectOption<PowerFilter>> = enumFilterOptions.powerFilter
  .filter(option => option.value === 'with_power' || option.value === 'without_power')

/**
 * 絞り込み条件を編集するハーフモーダル。
 * セクションの構成・文言はiOSアプリの絞り込み画面(ProductListFilterView)に、
 * カラーの選択肢(色の円アイコン・並び順)は既存のカラコン検索(SearchContactLens)の絞り込みUIに合わせている。
 *
 * ページ非依存の入力部品(Controlled)に徹する: 編集対象のクエリはvalueで受け取り、変更はinputで返すのみ。
 * URL・履歴・API通信(候補・件数の取得)は呼び出し側の責務で、このコンポーネントは関与しない。
 * シート・focus trap・背景ロックは既存の共通部品HalfModalに任せる。
 */
export default Vue.extend({
  components: {
    HalfModal,
  },
  props: {
    /**
     * レンズサイズ(着色直径・BC・DIA)の候補の取得状態。取得(先読み・再試行)は呼び出し側が所有し、
     * ここではsuccessの候補を選択肢に、loading / errorを該当セクションのプレースホルダ表示に写すだけ。
     */
    lensSizeCandidates: {
      type: Object as PropType<LensSizeCandidatesState>,
      required: true,
    },
    /**
     * 現在の編集内容に該当する商品の総数の取得状態。表示・活性の対応はDraftStatsのコメント参照。
     * 呼び出し側は条件が編集された時点でloadingへ戻す(古い件数を編集後の条件の件数として見せない)。
     */
    stats: {
      type: Object as PropType<DraftStats>,
      required: true,
    },
    /**
     * 編集対象の絞り込み条件。ItemListConditionは「ページの絞り込み条件」の正規形で、
     * URL・BFFリクエスト・チップ表示はすべてここから導出される(condition.tsのdocblock参照)。
     * FilterModalがAPIリクエスト用のクエリを組み立てているわけではない。
     */
    value: {
      type: Object as PropType<ItemListCondition>,
      required: true,
    },
  },
  data() {
    return {
      astigmatismDefinition,
      colorOptionDefinitions,
      colorOptions: colorFamilyOptions(),
      expirationPeriodOptions,
      hasBorderOptions: enumFilterOptions.hasBorder,
      highPowerOptions: enumFilterOptions.highPowerFilter,
      keywordDebounceTimer: null as number | null,
      // 入力欄の表示用のローカル値。親のvalue.qは通知の遅延(KEYWORD_DEBOUNCE_MS)のぶん入力より遅れるため、
      // 表示を親の値に結び付けると、遅延中の非同期な再描画(件数取得の完了等)が入力中のDOM値を
      // 古い値で巻き戻してしまう(IME変換中なら変換が破棄され未変換のまま強制確定される)
      keywordDraft: this.value.q,
      optionDefinitions,
      powerOptions,
      saleDefinitions,
      waterContentOptions: enumFilterOptions.waterContentFilter,
    }
  },
  watch: {
    // 変更の検知はv-modelの後段のこのwatchで行う。v-modelのcomposition対応(IME変換中はモデル更新も
    // valueの書き戻しもしない。compositionendで確定)に乗るためで、rawの@inputでは変換中の入力を拾ってしまう
    keywordDraft(next: string): void {
      this.cancelScheduledKeyword()
      this.keywordDebounceTimer = window.setTimeout(
        () => {
          this.keywordDebounceTimer = null
          // 発火時点で親へ反映済みの値と同じなら通知しない(クリア操作の即時通知の後に走る予約を無害化する)
          if (next === this.value.q) {
            return
          }
          this.$emit('input', setKeyword(this.value, next))
        },
        KEYWORD_DEBOUNCE_MS
      )
    },
  },
  beforeDestroy() {
    // 閉じた後に保留中の入力通知が飛ばないようにする
    this.cancelScheduledKeyword()
  },
  computed: {
    applyDisabled(): boolean {
      return this.stats.state === 'success' && this.stats.total === 0
    },
    applyLabel(): string {
      const stats = this.stats
      // loading / error は件数を出さない(更新中に古い件数を見せない。失敗しても適用は妨げない)
      if (stats.state !== 'success') {
        return 'この条件で表示'
      }

      return stats.total === 0 ? '該当商品なし' : `${stats.total}件を表示`
    },
    // successのときはnull(=候補を選択肢として表示する)
    candidatesPlaceholder(): string | null {
      const candidatesState = this.lensSizeCandidates
      if (candidatesState.state === 'success') {
        return null
      }

      return candidatesState.state === 'loading' ? '読み込み中' : '読み込みに失敗しました。'
    },
  },
  methods: {
    /**
     * トグルボタンの選択状態を、見た目(class)とアクセシビリティAPI(aria-pressed)の両方へ反映する。
     * 2属性の同期が片方だけ更新されて壊れないよう、テンプレートからはこれ1つをv-bindで展開する。
     */
    chipAttrs(active: boolean): { 'class': { [key: string]: boolean }, 'aria-pressed': string } {
      return {
        class: {
          'hl-filter__chip': true,
          'hl-filter__chip--active': active,
        },
        'aria-pressed': active ? 'true' : 'false',
      }
    },
    isArraySelected(key: StringArrayFilterKey, value: string): boolean {
      return this.value[key].indexOf(value) >= 0
    },
    isExpirationPeriodSelected(value: ExpirationPeriod): boolean {
      return this.value.expirationPeriod.indexOf(value) >= 0
    },
    // 条件の更新規則はモデルの操作関数(condition.ts)が持ち、ここは選択肢と操作を紐付けるだけ
    toggleArray(key: StringArrayFilterKey, value: string): void {
      this.$emit('input', toggleArrayValue(this.value, key, value))
    },
    toggleBoolean(key: BooleanFilterKey): void {
      this.$emit('input', toggleBooleanFilter(this.value, key))
    },
    toggleEnum<K extends EnumFilterKey>(key: K, value: EnumFilterValues[K]): void {
      this.$emit('input', toggleEnumFilter(this.value, key, value))
    },
    toggleExpirationPeriod(value: ExpirationPeriod): void {
      this.$emit('input', toggleExpirationPeriod(this.value, value))
    },
    /**
     * 適用。通知待ちのキーワードが残っていれば、applyより先に同期的に確定させる。
     * 入力から300ms以内に適用されると、親は古い条件を適用してモーダルを破棄し、
     * beforeDestroyが保留タイマーを片付けるため、最後の入力が無言で失われる。
     */
    apply(): void {
      this.cancelScheduledKeyword()
      if (this.keywordDraft !== this.value.q) {
        this.$emit('input', setKeyword(this.value, this.keywordDraft))
      }
      this.$emit('apply')
    },
    // クリアボタンはタップ操作なので遅延させず、保留中の入力通知も破棄する
    clearKeyword(): void {
      this.cancelScheduledKeyword()
      this.keywordDraft = ''
      this.$emit('input', setKeyword(this.value, ''))
    },
    // 全条件のクリア(footer)。親がvalueを既定値に戻すので、表示用のローカル値も揃えて空にする
    onClear(): void {
      this.cancelScheduledKeyword()
      this.keywordDraft = ''
      this.$emit('clear')
    },
    cancelScheduledKeyword(): void {
      if (this.keywordDebounceTimer !== null) {
        window.clearTimeout(this.keywordDebounceTimer)
        this.keywordDebounceTimer = null
      }
    },
  },
})
